/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import {
  AxiosInstance,
  InternalAxiosRequestConfig,
  AxiosError,
  AxiosResponse,
  AxiosRequestHeaders,
} from 'axios';
import { validateResponse } from './schemaValidator';
import { ZodType } from 'zod';
import { getPlatformInfo } from './platformInfo';
import { Platform } from 'react-native';

const defaultHeaders = {} as AxiosRequestHeaders;

export const userAgentInterceptor = (
  client: AxiosInstance,
  appName: string,
  appVersion: string,
): AxiosInstance => {
  const platformInfo = getPlatformInfo();

  client.interceptors.request.use(async (config) => {
    config.headers = config.headers || defaultHeaders;
    if (Platform.OS === 'web') {
      config.headers['X-User-Agent'] =
        `${appName}/${appVersion} ${platformInfo}`;
    } else {
      config.headers['User-Agent'] = `${appName}/${appVersion} ${platformInfo}`;
    }
    return config;
  });

  return client;
};

export const loggingRequestResponseInterceptor = (client: AxiosInstance) => {
  client.interceptors.request.use(
    (request: InternalAxiosRequestConfig) => {
      //for logging request
      return request;
    },
    (error: AxiosError) => {
      return Promise.reject(error);
    },
  );

  client.interceptors.response.use((response: AxiosResponse) => {
    //for logging response
    return response;
  });

  return client;
};

export const schemaValidateInterceptor = (
  client: AxiosInstance,
  schema: ZodType,
) => {
  client.interceptors.response.use((response: AxiosResponse) => {
    return validateResponse(schema, response);
  });

  return client;
};
